const CONTAINER_ID = 'toast-container';
const LEVELS = {
    info:    { icon: 'fa-circle-info',         classes: 'bg-blue-50 border-blue-300 text-blue-900' },
    success: { icon: 'fa-circle-check',        classes: 'bg-green-50 border-green-300 text-green-900' },
    warning: { icon: 'fa-triangle-exclamation', classes: 'bg-amber-50 border-amber-300 text-amber-900' },
    error:   { icon: 'fa-circle-xmark',        classes: 'bg-red-50 border-red-300 text-red-900' },
};

function ensureContainer() {
    let container = document.getElementById(CONTAINER_ID);
    if (!container) {
        container = document.createElement('div');
        container.id = CONTAINER_ID;
        container.className = 'fixed bottom-6 left-1/2 -translate-x-1/2 z-[300] flex flex-col gap-2 pointer-events-none';
        document.body.appendChild(container);
    }
    return container;
}

/**
 * Show a transient toast notification to the user.
 * @param {string} message - User-facing text. MUST be safe (already escaped or trusted source).
 * @param {object} [opts]
 * @param {'info'|'success'|'warning'|'error'} [opts.level='info']
 * @param {number} [opts.duration=3500] - ms before autodismiss. Pass 0 for no autodismiss.
 */
export function showToast(message, { level = 'info', duration = 3500 } = {}) {
    const config = LEVELS[level] || LEVELS.info;
    const container = ensureContainer();

    const toast = document.createElement('div');
    toast.className = `${config.classes} border rounded-xl shadow-lg px-4 py-3 max-w-sm flex items-center gap-3 pointer-events-auto transition-opacity duration-300 opacity-0`;
    toast.setAttribute('role', level === 'error' ? 'alert' : 'status');
    toast.setAttribute('aria-live', level === 'error' ? 'assertive' : 'polite');

    const icon = document.createElement('i');
    icon.className = `fa-solid ${config.icon} text-base shrink-0`;
    toast.appendChild(icon);

    const text = document.createElement('span');
    text.className = 'text-sm font-medium';
    text.textContent = message;
    toast.appendChild(text);

    container.appendChild(toast);

    requestAnimationFrame(() => { toast.classList.remove('opacity-0'); });

    if (duration > 0) {
        setTimeout(() => {
            toast.classList.add('opacity-0');
            setTimeout(() => { toast.remove(); }, 300);
        }, duration);
    }

    return toast;
}
